import { render, staticRenderFns } from "./WinnerInfo.vue?vue&type=template&id=8bca058c&scoped=true&"
import script from "./WinnerInfo.vue?vue&type=script&lang=js&"
export * from "./WinnerInfo.vue?vue&type=script&lang=js&"
import style0 from "./WinnerInfo.vue?vue&type=style&index=0&id=8bca058c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bca058c",
  null
  
)

export default component.exports